import { render, staticRenderFns } from "./Bithdate.vue?vue&type=template&id=afc07156&"
import script from "./Bithdate.vue?vue&type=script&lang=js&"
export * from "./Bithdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports